export default {"src":"/_next/static/media/GoldBit.4d80ccc9.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};